import { IPoint, IProvider, ILocation, IAddress } from '../models';


export function rad(x){
  return x * Math.PI / 180;
}

export function getDistance(p1: IPoint, p2: IPoint): number{
  const R = 6378137; // Earth’s mean radius in meter
  const dLat = rad(p2.latitude - p1.latitude);
  const dLong = rad(p2.longitude - p1.longitude);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.latitude)) * Math.cos(rad(p2.latitude)) *
    Math.sin(dLong / 2) * Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d; // returns the distance in meter
}

export function  getDistanseMiles(p1: IPoint, p2: IPoint): number{
  const meters = getDistance(p1, p2);
  return Math.round(meters / 1609.34);
}

export function calcProviderDistance(userLocation: ILocation, provider: IProvider): number{
  let distance = null;
  const userPoint: IPoint = { latitude: userLocation.latitude, longitude: userLocation.longitude };
  const offices: IAddress[] = provider.clinics || [];
  offices.push(provider.main_office);

  for(const office of offices){
    const officePoint: IPoint ={
      latitude: office.latitude,
      longitude: office.longitude
    };
    const officeDistance = getDistanseMiles(userPoint, officePoint);
    if(distance === null || distance > officeDistance){
      distance = officeDistance;
    }
  }
  return distance;
}
